import(/* webpackMode: "eager" */ "/www/wwwroot/mastermindevent.id/mastermind-next/app/(events)/[slug]/twibbon/twibbon-campaign.tsx")